import * as React from 'react';
import { LeadingTrailingContentMenuItemDefinition } from './AmorgMenuTypes';
import { StyledToolTip } from './helpers/StyledTooltip';
import { BaseButton } from './helpers/BaseButton';
import { TrailingContent } from './contentTypes/TrailingContent';
import { PrimaryContent } from './contentTypes/PrimaryContent';
import { LeadingContent } from './contentTypes/LeadingContent';
import { getFlex } from './helpers/flexHelper';
import { Flex } from '../compositeComponents/FlexHelpers';


type PropsWithoutType = Omit<LeadingTrailingContentMenuItemDefinition, "type">;

export function LeadingTrailingContentMenuItem(props:PropsWithoutType)
    :JSX.Element
{
    const [isHovering, setIsHovering] = React.useState(false);

    const flexes = getFlex(props.primaryContent, props.trailingContent);

    return (
        <BaseButton 
            selected={props.selectedState || false}
            styleVariant={props.styleVariant}
            isHovering={props.onClick && isHovering}
            onClick={props.onClick} 
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)} >

            <Flex alignItems="flex-start">
                
                <LeadingContent {...props.leadingContent} onClick={props.onClick} isHovering={isHovering} styleVariant={props.styleVariant} />

                <PrimaryContent {...props.primaryContent} onClick={props.onClick} isHovering={isHovering} styleVariant={props.styleVariant} flex={flexes.primaryContentFlex} />

                <TrailingContent {...props.trailingContent} onClick={props.onClick} isHovering={isHovering} styleVariant={props.styleVariant} flex={flexes.trailingContentFlex} />

            </Flex>
            
            {/* should go into BaseButton */}
            {props.toolTip && isHovering &&
                <StyledToolTip>{props.toolTip}</StyledToolTip>
            }

        </BaseButton>
    );
}
